export default __webpack_public_path__ + "static/media/icon_audio_loading.3187cc35.svg";